<template>
    <div>
        <template v-if="permission === true">
            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left">Account Types</h1>
                <router-link to="/addAccountTypes" class="btn btn-primary float-right active"> Add New Type of Account</router-link>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" name="" />
                </div>
            </div>
            <table id="Table" class="table">
                <thead>
                    <tr>
                        <th style="display: none;"></th>
                        <th>Type</th>
                        <th>Risk Rating</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="permission === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="permission === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                permission : null,
            };
        },
        mounted() {
            this.$Progress.start();
            var gThat = this;
            this.can('cities').then(result => {
                this.permission = result.cities;
            }).then(result => {
                if(this.permission == true){
                    this.callDatatable();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
            window.softDelete = function(id){
                gThat.softDelete(id);
            }
        },
        methods: {
            callDatatable(){
                var that = this;Table
                var Table =  $('#Table').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/listAccountTypes",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'type'},
                        {data: 'risk_rating', render: function(data, type, full) {
                                if (data <= 5) {
                                    return 'Low';
                                } else if (data > 5 && data <= 10) {
                                    return 'Medium';
                                } else if (data > 10) {
                                    return 'High';
                                } else {
                                    return 'NA'; // Handle any other cases
                                }
                            }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editAccountTypes/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit"><i class="fas fa-pencil-alt"></i></a><a href="javascript:void(0);" onClick="window.softDelete('+full['id']+')"  data-toggle="tooltip" data-placement="top" title="Delete" class="action edit"> <i class="fas fa-trash-alt"></i> </a>';
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 3 ]
                    }],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
                $('#customSearch').on( 'keyup', function () {
                    Table.search(this.value).draw();
                });
            },
            softDelete(id) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You want to delete this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        axios.post("/api/softDeleteAccountType", {id: id})
                            .then(res => {
                                if(res.status == 200){
                                    this.showToastBox('success','record deleted successfully!');
                                    this.$router.go(this.$router.currentRoute);
                                    this.$Progress.finish();
                                }else{
                                    this.$Progress.fail();
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Oops...',
                                        text: 'Something went wrong!',
                                    })
                                }
                            })
                            .catch(err => {
                                console.log(err);
                                this.$Progress.fail();
                                this.showAlertBox('error','couldnt find requested data');
                            });
                    }
                })
            }
        }
    }
</script>
